module.exports = new __parcel__URL__("bossfight_rounds_button.eb15f416.png").toString();